import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import GenericButton from "@/components/buttons/GenericButton.vue";
import { AllMutationTypes } from "@/store/mutationTypes";
import { GenericButtonVariantEnum } from "@/types/button";
import { computed } from "vue";
import { useStore } from "vuex";

interface Props {
  text?: string;
  variant?: GenericButtonVariantEnum;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupCancelButton',
  props: {
    text: { default: "" },
    variant: { default: GenericButtonVariantEnum.Secondary }
  },
  setup(__props: any) {

const { commit } = useStore();

const props = __props;

const appliedText = computed<string>(() => {
  const textProperty = props.text
    ? props.text
    : "popup.PopupCancelButton.btnText";

  return textProperty;
});

const handleCancel = () => {
  commit(AllMutationTypes.HIDE_POPUP, true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GenericButton, {
    variant: _ctx.variant,
    text: appliedText.value,
    "on-click": handleCancel
  }, null, 8, ["variant", "text"]))
}
}

})